import { render, staticRenderFns } from "./lawStatute.vue?vue&type=template&id=faeb0d02&scoped=true&"
import script from "./lawStatute.vue?vue&type=script&lang=js&"
export * from "./lawStatute.vue?vue&type=script&lang=js&"
import style0 from "./lawStatute.vue?vue&type=style&index=0&id=faeb0d02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faeb0d02",
  null
  
)

export default component.exports